import { Spinner } from './spinner';
import { SpinnerSizes } from './interfaces';
export default Spinner;
